import { render } from "./TimeslotSelector.vue?vue&type=template&id=95329c78&scoped=true"
import script from "./TimeslotSelector.vue?vue&type=script&lang=js"
export * from "./TimeslotSelector.vue?vue&type=script&lang=js"

import "./TimeslotSelector.vue?vue&type=style&index=0&id=95329c78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95329c78"]])

export default __exports__